import {
  Box,
  Button,
  FormLabel,
  IconButton,
  Input,
  InputLeftAddon,
  Select,
  Text,
  useToast,
  InputGroup,
} from "@chakra-ui/react";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
const userData = {};

export default function RegisterForm({ register }) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [forbidden, setForbidden] = useState(false);
  const [industries, setIndustries] = useState([]);
  // const [step1InValid, setStep1InValid] = useState(true);
  const [countryCode, setCountryCode] = useState("");
  const toast = useToast();

  const validateFormOne = (values) => {
    const errors = {};

    // validate email
    if (!values.email) {
      errors.email = "Required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }

    // validate phone Number
    if (!values.phone) {
      errors.phone = "Phone number is required";
    } else if (values.phone.length < 8) {
      errors.phone = "Must be minimum of 8 keywords";
    }

    // validate password
    if (!values.password) {
      errors.password = "Password is required";
    } else if (values.password.length < 8) {
      errors.password = "Must be minimum of 8 keywords";
    }
    return errors;
  };

  useEffect(() => {
    setCountryCode("234");
  }, []);
  useEffect(() => {
    return axios
      .get(`${process.env.REACT_APP_BASE_API}industries`)
      .then((res) => {
        setIndustries(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        toast({
          title: "Error",
          description: `Error occurred while getting list of industries`,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
        return;
      });
  }, [toast]);

  const formOne = useFormik({
    initialValues: {
      email: "",
      password: "",
      industry: "",
    },
    validate: validateFormOne,
    onSubmit: (values) => {
      Object.assign(userData, values);
      setStep(2);
    },
  });

  const formTwo = useFormik({
    initialValues: {
      industry: "",
    },
    validate: (values) => {
      const errors = {};
      if (
        values.industry === "" ||
        values.industry.toLocaleLowerCase() === "select your industry"
      ) {
        errors.industry = "Select an industry from the dropdown";
      }
      return errors;
    },
    onSubmit: (values) => {
      // merges values from formOne into formOne
      if (
        values.industry.toLowerCase() === "student" ||
        values.industry.toLowerCase() === "job seeker"
      ) {
        return setForbidden(true);
      }
      Object.assign(userData, values);

      setLoading(true);

      // get the index of the selected index to use in getting the id
      let industryIndex = industries.findIndex(
        (industry) => industry.title === userData.industry
      );

      let data = {
        email: userData.email,
        phone: userData.phone,
        password: userData.password,
        industry: industries[industryIndex]._id,
      };

      register(data)
        .then((res) => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);

          console.log({ err });
          if (err.response && err.response.data.status === false) {
            // not authorized!
            return toast({
              title: "Error",
              description: err.response.data.message,
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
          // some error occurred
          return toast({
            title: "Error",
            description: "Something went wrong, please try again",
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        });
    },
  });

  return (
    <>
      <Box sx={{ gridArea: "body" }}>
        {!forbidden ? (
          <Box>
            <Box px={8}>
              {/* step1 */}
              {step === 1 && (
                <Box as="form" onSubmit={formOne.handleSubmit}>
                  <Box>
                    <FormLabel htmlFor="email">Email Address</FormLabel>
                    <Input
                      id="email"
                      type="email"
                      name="email"
                      onChange={formOne.handleChange}
                      value={formOne.values.email}
                    />

                    {formOne.errors.email ? (
                      <Text color="red.500" fontSize="sm" mt={3}>
                        {formOne.errors.email}
                      </Text>
                    ) : null}
                  </Box>

                  <Box mt={4}>
                    <FormLabel htmlFor="password">Phone Number</FormLabel>

                    <InputGroup>
                      <InputLeftAddon children={countryCode} />
                      <Input
                        type="tel"
                        name="phone"
                        id="phone"
                        onChange={formOne.handleChange}
                        value={formOne.values.phone}
                      />
                    </InputGroup>
                    {formOne.errors.phone ? (
                      <Text color="red.500" fontSize="sm" mt={3}>
                        {formOne.errors.phone}
                      </Text>
                    ) : null}
                  </Box>

                  <Box mt={4}>
                    <FormLabel htmlFor="password">Password</FormLabel>
                    <Input
                      id="password"
                      type="password"
                      name="password"
                      onChange={formOne.handleChange}
                      value={formOne.values.password}
                    />

                    {formOne.errors.password ? (
                      <Text color="red.500" fontSize="sm" mt={3}>
                        {formOne.errors.password}
                      </Text>
                    ) : null}
                  </Box>

                  <Button
                    mt={8}
                    isFullWidth
                    colorScheme="light"
                    bg="#00A2E8"
                    isLoading={formOne.isValidating}
                    isDisabled={!formOne.isValid}
                    type="submit"
                  >
                    Continue
                  </Button>
                </Box>
              )}

              {/* step 2 */}
              {step === 2 && (
                <>
                  <IconButton
                    bg="#213C5C"
                    colorScheme="blue"
                    aria-label="Search database"
                    onClick={() => setStep(1)}
                    mb={4}
                    icon={<FontAwesomeIcon size="lg" icon={faCaretLeft} />}
                  />
                  <Box as="form" onSubmit={formTwo.handleSubmit}>
                    <Box>
                      <FormLabel htmlFor="industry">I am a</FormLabel>
                      <Select
                        id="industry"
                        name="industry"
                        onChange={formTwo.handleChange}
                        value={formTwo.values.industry}
                      >
                        {/* while industries are still being fetched from the api, display a loading notifier to the user */}
                        {!industries.length > 0 && (
                          <>
                            <option>Loading...</option>
                          </>
                        )}

                        {/* display industries as options */}
                        {industries.length > 0 && (
                          <>
                            <option>Select your industry</option>

                            {industries.map((industry) => (
                              <option> {industry.title} </option>
                            ))}
                          </>
                        )}
                      </Select>

                      {formTwo.errors.industry ? (
                        <Text color="red.500" fontSize="sm" mt={3}>
                          {formTwo.errors.industry}
                        </Text>
                      ) : null}
                    </Box>

                    <Button
                      mt={8}
                      isFullWidth
                      colorScheme="light"
                      bg="#00A2E8"
                      isLoading={loading}
                      type="submit"
                      isDisabled={!formTwo.isValid}
                    >
                      Register
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Box>
        ) : (
          <Box sx={{ gridArea: "body" }} px={8}>
            <Box px={8} mt={16} sx={{ textAlign: "center" }}>
              <Text mb="3">We’re Sorry</Text>

              <Text>
                You cannot register as a student or Job seeker. Ask your school
                or company to invite you to Learnerkia.
              </Text>
            </Box>

            <Button
              mt={8}
              isFullWidth
              colorScheme="light"
              bg="#00A2E8"
              isLoading={loading}
              as="a"
              href="/"
            >
              Back To Home
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}
